import { Component } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from '../../../core/helpers/helper';
import { Validations } from '../../../shared/constants/validations';
import { SharedService } from '../../../shared/shared.service';
import {
  createdevice,
  resetDevicesState,
  updatedevice,
} from '../../../store/iot-devices/iot-devices.actions';
import {
  createdeviceResponse,
  updatedeviceResponse,
} from '../../../store/iot-devices/iot-devices-selector';
import { DeviceService } from '../../../core/services/deivce.services';
import { SweetAlertIcon } from '../../../shared/constants/enum';
@Component({
  selector: 'app-iot-create-devices',
  templateUrl: './iot-create-devices.component.html',
  styleUrl: './iot-create-devices.component.scss',
})
export class IotCreateDevicesComponent {
  deviceForm!: UntypedFormGroup;
  isAllOpen: boolean = true;
  selectValue!: string[];
  configData: any;
  supplierData: any = [];
  deviceValidations = Validations.devices;
  submitted: boolean = false;
  deviceDetails: any = null;
  breadCrumbItems: Array<{}> | undefined;
  /*  Macregex = /^[0-9A-F]{16}$/;
  regex = /^[A-Z0-9]*$/;
  IsWiredMacregex = /^[0-9]{7}$/; */
  Macregex = /^[0-9A-F]+$/;
  // Macregex = /^(?=.*[0-9])(?=.*[A-F])[0-9A-F]+$/;
  IsWiredMacregex = /^[0-9]+$/;
  meterIswired = /^[A-Z0-9]+$/;
  regex = /^[A-Z0-9]*$/;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private store: Store,
    private route: ActivatedRoute,
    public sharedService: SharedService,
    private router: Router,
    private deviceService: DeviceService,
  ) {
    this.getStoreData();
    this.deviceDetails = history.state?.deviceDetails
      ? JSON.parse(history.state.deviceDetails)
      : null;
    this.breadCrumbItems = [
      { label: 'Iot Devices', url: 'iotDevices', active: true },
      { label: this.deviceDetails ? 'Edit Iot Devices' : 'Create Iot Devices' },
    ];
  }
  utilityTypes = [
    { label: 'Residential', value: 'Residential' },
    { label: 'Commercial', value: 'Commercial' }
];

  getStoreData() {
    this.store.dispatch(resetDevicesState()); // Optionally reset state
    let createdeviceResponse$ = this.store.pipe(select(createdeviceResponse));
    let updatedeviceResponse$ = this.store.pipe(select(updatedeviceResponse));
    createdeviceResponse$.subscribe((res: any) => {
      console.log(res);

      this.loaderService.setLoading(false);
      if (res) {
        this.router.navigate(['/iotDevices']);
      }
    });

    updatedeviceResponse$.subscribe((res: any) => {
      console.log(res);

      this.loaderService.setLoading(false);
      if (res) {
        this.router.navigate(['/iotDevices']);
      }
    });
  }

  ngOnInit(): void {
    this.getAllConfigData();

    this.deviceForm = this.formBuilder.group({
      deviceSRNo: [
        '',
        [
          Validators.required,
          Validators.maxLength(16),
          Validators.minLength(7),
          Validators.pattern(this.regex),
        ],
      ],
      canId: [
        '',
        [
          
          Validators.minLength(9),
          Validators.maxLength(9),
             Validators.pattern(/^[A-Za-z0-9]*$/),
        ],
      ],

      macAddress: [
        '',
        [
          Validators.required,
          Validators.pattern(this.Macregex),
          Validators.maxLength(16),
          Validators.minLength(16),
        ],
      ],
      utilityType: ['', Validators.required],
      masterId: [null, [Validators.required]],
      supplierId: [null, [Validators.required]],
      projectId: [null, [Validators.required]],
      yearOfMake: ['', [Validators.required]],
      responseConfigurationId: [null, [Validators.required]],
      isMonitoringDevice: [false, [Validators.required]],
      isWiredCommunicationDevice: [false],
      gatewayInformationId: [null],
      meterReading: [0],
      meterReadingEB: [0],
      meterReadingDG: [0],
      meterReadingTS: [0],
      // deviceId:[null,  [  Validators.pattern(/^\d+$/) ]],
      deviceId: [
        '',
        [
          // Validators.maxLength(10),
          //Validators.pattern(/^\d+$/),
        ],
      ],
    });
    console.log(this.deviceDetails);
    if (this.deviceDetails) {
      this.iswirdeCommunication = this.deviceDetails.isWiredCommunicationDevice;
      const year = parseInt(this.deviceDetails.yearOfMake, 10);
      const yearDate = new Date(year, 0, 1);
      this.deviceForm.patchValue({
        deviceSRNo: this.deviceDetails.deviceSRNo,
        macAddress: this.deviceDetails.macAddress,
        masterId: this.deviceDetails.category.id,
        utilityType: this.deviceDetails?.utilityType ?? '',
        supplierId: this.deviceDetails.supplier.id,
        projectId: this.deviceDetails.projectId,
        yearOfMake: yearDate,
        responseConfigurationId: this.deviceDetails.responseConfiguration.id,
        isMonitoringDevice: this.deviceDetails.isMonitoringDevice,
        isWiredCommunicationDevice:
          this.deviceDetails.isWiredCommunicationDevice,
        gatewayInformationId: this.deviceDetails.gatewayInformationId,
        meterReading: this.deviceDetails?.meterReading || 0,
        meterReadingEB: this.deviceDetails?.meterReadingEB || 0,
        meterReadingDG: this.deviceDetails?.meterReadingDG || 0,
        meterReadingTS: this.deviceDetails?.meterReadingTS || 0,
        deviceId: this.deviceDetails?.deviceId || null,
        canId: this.deviceDetails?.canID || '',
      });

      let utility = { id: this.deviceDetails?.category?.id };
      // this.onUtility(utility);
      console.log(this.deviceDetails.isWiredCommunicationDevice);
      if (this.deviceDetails.isWiredCommunicationDevice) {
        this.deviceForm
          .get('gatewayInformationId')
          ?.setValidators([Validators.required]);

        this.deviceForm
          .get('deviceId')
          ?.setValidators([Validators.required, Validators.pattern(/^\d+$/)]);
        this.deviceForm
          .get('macAddress')
          ?.setValidators([
            Validators.required,
            Validators.pattern(this.IsWiredMacregex),
            Validators.maxLength(16),
            Validators.minLength(7),
          ]);

        this.deviceForm
          .get('deviceSRNo')
          ?.setValidators([
            Validators.required,
            Validators.pattern(this.meterIswired),
            Validators.maxLength(7),
            Validators.minLength(7),
          ]);
        this.deviceForm.get('deviceSRNo')?.updateValueAndValidity();
        this.deviceForm.get('macAddress')?.updateValueAndValidity();
      } else {
        this.deviceForm.get('gatewayInformationId')?.clearValidators();
        this.deviceForm.get('deviceId')?.clearValidators();
        this.deviceForm.get('deviceId')?.updateValueAndValidity();
        this.deviceForm
          .get('macAddress')
          ?.setValidators([
            Validators.pattern(this.Macregex),
            Validators.maxLength(16),
            Validators.required,
            Validators.minLength(7),
          ]);
        this.deviceForm
          .get('deviceSRNo')
          ?.setValidators([
            Validators.required,
            Validators.pattern(this.regex),
            Validators.maxLength(16),
            Validators.minLength(7),
          ]);
        this.deviceForm.get('deviceSRNo')?.updateValueAndValidity();
        this.deviceForm.get('macAddress')?.updateValueAndValidity();
        this.deviceForm.get('gatewayInformationId')?.updateValueAndValidity();
      }

      this.updateValidations();
      // alert("hgf"+this.deviceForm.get('masterId')?.value)

      // alert(this.configData.utilities.find((item:any) => item.id ===  this.deviceForm.get('masterId')?.value)?.name)
    }

    // this.deviceForm.get('masterId')?.valueChanges.subscribe((value) => {
    //   alert()
    //   this.updateValidations();
    // });
  }

  getUtilityName() {
    return this.configData.utilities.find(
      (item: any) => item.id === this.deviceForm.get('masterId')?.value,
    )?.name;
  }
  getAllConfigData(): void {
    this.sharedService.getAllConfigData().subscribe((data) => {
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
        this.configData = data.data;
        let utility = { id: this.deviceDetails?.category?.id };
        // this.onUtility(utility);
        if (this.deviceForm.get('masterId')?.value) {
          if (this.getUtilityName() == 'Electricity') {
            this.deviceForm
              .get('meterReadingDG')
              ?.setValidators([Validators.required]);
            this.deviceForm
              .get('meterReadingEB')
              ?.setValidators([Validators.required]);
            this.deviceForm.get('meterReading')?.clearValidators();
          } else if (this.getUtilityName() == 'TriSource') {
            this.deviceForm
              .get('meterReadingDG')
              ?.setValidators([Validators.required]);
            this.deviceForm
              .get('meterReadingEB')
              ?.setValidators([Validators.required]);
            this.deviceForm.get('meterReading')?.clearValidators();
            this.deviceForm
              .get('meterReadingTS')
              ?.setValidators([Validators.required]);
          } else {
            this.deviceForm.get('meterReadingDG')?.clearValidators();
            this.deviceForm.get('meterReadingEB')?.clearValidators();
            this.deviceForm.get('meterReadingTS')?.clearValidators();
            this.deviceForm
              .get('meterReading')
              ?.setValidators([Validators.required]);
          }

          this.deviceForm.get('meterReadingDG')?.updateValueAndValidity();
          this.deviceForm.get('meterReadingEB')?.updateValueAndValidity();
          this.deviceForm.get('meterReading')?.updateValueAndValidity();
          this.deviceForm.get('meterReadingTS')?.updateValueAndValidity();
        } else {
          this.deviceForm.get('meterReadingDG')?.clearValidators();
          this.deviceForm.get('meterReadingEB')?.clearValidators();
          this.deviceForm.get('meterReading')?.clearValidators();
          this.deviceForm.get('meterReadingTS')?.clearValidators();
          this.deviceForm.get('meterReadingDG')?.updateValueAndValidity();
          this.deviceForm.get('meterReadingEB')?.updateValueAndValidity();
          this.deviceForm.get('meterReading')?.updateValueAndValidity();
          this.deviceForm.get('meterReadingTS')?.updateValueAndValidity();
        }
      }
    });
  }
  UtilityCheckForWaterandGas() {
    console.log(this.getUtilityName());
    return (
      this.getUtilityName() == 'Electricity' ||
      this.getUtilityName() == 'TriSource'
    );
  }

  updateValidations() {
    if (this.getUtilityName()) {
      if (this.getUtilityName() == 'Electricity') {
        this.deviceForm
          .get('meterReadingDG')
          ?.setValidators([Validators.required]);
        this.deviceForm
          .get('meterReadingEB')
          ?.setValidators([Validators.required]);
        this.deviceForm.get('meterReading')?.clearValidators();
      } else if (this.getUtilityName() == 'TriSource') {
        this.deviceForm
          .get('meterReadingDG')
          ?.setValidators([Validators.required]);
        this.deviceForm
          .get('meterReadingEB')
          ?.setValidators([Validators.required]);
        this.deviceForm.get('meterReading')?.clearValidators();
        this.deviceForm
          .get('meterReadingTS')
          ?.setValidators([Validators.required]);
      } else {
        this.deviceForm.get('meterReadingDG')?.clearValidators();
        this.deviceForm.get('meterReadingEB')?.clearValidators();
        this.deviceForm.get('meterReadingTS')?.clearValidators();
        this.deviceForm.get('gatewayInformationId')?.clearValidators();
        this.deviceForm.get('deviceId')?.clearValidators();

        this.deviceForm.patchValue({
          isMonitoringDevice: false,
          isWiredCommunicationDevice: false,
          gatewayInformationId: null,
          deviceId: null,
        });

        this.deviceForm
          .get('meterReading')
          ?.setValidators([Validators.required]);
      }

      this.deviceForm.get('deviceId')?.updateValueAndValidity();
      this.deviceForm.get('gatewayInformationId')?.updateValueAndValidity();
      this.deviceForm.get('meterReadingDG')?.updateValueAndValidity();
      this.deviceForm.get('meterReadingEB')?.updateValueAndValidity();
      this.deviceForm.get('meterReading')?.updateValueAndValidity();
      this.deviceForm.get('meterReadingTS')?.updateValueAndValidity();
    } else {
      this.deviceForm.get('meterReadingDG')?.clearValidators();
      this.deviceForm.get('meterReadingEB')?.clearValidators();
      this.deviceForm.get('meterReading')?.clearValidators();
      this.deviceForm.get('meterReadingTS')?.clearValidators();
      this.deviceForm.get('meterReadingDG')?.updateValueAndValidity();
      this.deviceForm.get('meterReadingEB')?.updateValueAndValidity();
      this.deviceForm.get('meterReading')?.updateValueAndValidity();
      this.deviceForm.get('meterReadingTS')?.updateValueAndValidity();
    }
  }

  onUtility(utility: any) {
    console.log(utility);
    this.configData;
    this.supplierData = this.configData?.suppliers.filter(
      (item: any) => item.master.id === utility.id,
    );
    if (this.deviceDetails) {
      this.deviceForm.patchValue({
        supplierId: this.deviceDetails?.supplier?.id,
      });
    }
  }
  onDateChange(date: any): void {
    const selectedDate = new Date(date);
    const year = selectedDate.getFullYear();

    // Update the form control to only store the year
    this.deviceForm.get('date_registered')?.setValue(year.toString());
  }

  onYearChange(date: Date): void {
    // Extract the year from the selected date and update the form control
    // const year = date.getFullYear();
    // date
    //   ? this.deviceForm.get('yearOfMake')?.setValue(date)
    //   : this.deviceForm.get('yearOfMake')?.setValue(null);
  }
  iswirdeCommunication: boolean = false;
  onSwitchChange(event: any): void {
    console.log('Switch value changed:', event);
    this.iswirdeCommunication = event;
    console.log('Switch value changed:', event);
    // Perform actions based on the new value
    if (event) {
      this.deviceForm
        .get('gatewayInformationId')
        ?.setValidators([Validators.required]);
      this.deviceForm
        .get('macAddress')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.IsWiredMacregex),
          Validators.maxLength(7),
          Validators.minLength(7),
        ]);

      this.deviceForm
        .get('deviceSRNo')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.meterIswired),
          Validators.maxLength(7),
          Validators.minLength(7),
        ]);
      this.deviceForm
        .get('deviceId')
        ?.setValidators([Validators.required, Validators.pattern(/^\d+$/)]);
      this.deviceForm.get('deviceId')?.updateValueAndValidity();
      this.deviceForm.get('deviceSRNo')?.updateValueAndValidity();
      this.deviceForm.get('macAddress')?.updateValueAndValidity();
    } else {
      this.deviceForm.get('gatewayInformationId')?.clearValidators();
      this.deviceForm
        .get('macAddress')
        ?.setValidators([
          Validators.pattern(this.Macregex),
          Validators.maxLength(16),
          Validators.required,
          Validators.minLength(16),
        ]);
      this.deviceForm
        .get('deviceSRNo')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(16),
          Validators.minLength(7),
        ]);
      this.deviceForm.get('deviceId')?.clearValidators();
      this.deviceForm.get('deviceId')?.updateValueAndValidity();
      this.deviceForm.get('deviceSRNo')?.updateValueAndValidity();
      this.deviceForm.get('macAddress')?.updateValueAndValidity();
    }
    this.deviceForm.get('gatewayInformationId')?.updateValueAndValidity();
  }

  private getBackendErrorMessage(response: any): string {
    return (
      response?.error?.message ||
      response?.message ||
      response?.error?.error?.message ||
      'Something went wrong. Please try again later.'
    );
  }

  saveDevice(type: string) {
    this.submitted = true;
    if (this.deviceForm.valid) {
      this.loaderService.setLoading(true);
      this.submitted = false;
      // Handle form submission
      console.log(
        'Form submitted successfully!',
        this.deviceForm.getRawValue(),
      );
      console.log(this.deviceForm.value);
      if (type == 'Save') {
        this.deviceService.createdevices(this.deviceForm.value).subscribe({
          next: (response: any) => {
            console.log(response);
            this.loaderService.setLoading(false);
            if (response?.statusCode === 201) {
              this.router.navigate(['/iotDevices']);
            } else {
              this.sharedService.showMessageDialog(
                'Failure',
                this.getBackendErrorMessage(response),
                SweetAlertIcon.ERROR,
              );
            }
          },
          error: (error: any) => {
            console.log(error);
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'Failure',
              this.getBackendErrorMessage(error),
              SweetAlertIcon.ERROR,
            );
          },
        });

        /*  this.store.dispatch(
           createdevice({
             deviceData: this.deviceForm.value,
           })
         ); */
        /* createdeviceResponse$.subscribe((res: any) => {
              console.log(res);
        
              this.loaderService.setLoading(false);
              if (res) {
                this.router.navigate(['/iotDevices']);
              }
            }); */
      } else {
        //console.log(this.deviceDetails?.lastMeterReadingUpdatedDate)
        // console.log(new Date(this.deviceDetails?.lastMeterReadingUpdatedDate))
        const payload = {
          deviceSRNo: this.deviceForm.get('deviceSRNo')?.value,
          macAddress: this.deviceForm.get('macAddress')?.value,
          masterId: this.deviceForm.get('masterId')?.value,
          supplierId: this.deviceForm.get('supplierId')?.value,
          projectId: this.deviceForm.get('projectId')?.value,
          yearOfMake: this.deviceForm.get('yearOfMake')?.value,
            utilityType: this.deviceForm.get('utilityType')?.value,
          responseConfigurationId: this.deviceForm.get(
            'responseConfigurationId',
          )?.value,
          isMonitoringDevice: this.deviceForm.get('isMonitoringDevice')?.value,
          isWiredCommunicationDevice: this.deviceForm.get(
            'isWiredCommunicationDevice',
          )?.value,
          gatewayInformationId: this.deviceForm.get('gatewayInformationId')
            ?.value,
          meterReading:
            this.getUtilityName() === 'Water' || this.getUtilityName() === 'Gas'
              ? Number(this.deviceForm.get('meterReading')?.value) || 0
              : 0,

          meterReadingEB:
            this.getUtilityName() === 'Electricity' ||
            this.getUtilityName() === 'TriSource'
              ? Number(this.deviceForm.get('meterReadingEB')?.value) || 0
              : 0,

          meterReadingDG:
            this.getUtilityName() === 'Electricity' ||
            this.getUtilityName() === 'TriSource'
              ? Number(this.deviceForm.get('meterReadingDG')?.value) || 0
              : 0,

          meterReadingTS:
            this.getUtilityName() === 'TriSource'
              ? Number(this.deviceForm.get('meterReadingTS')?.value) || 0
              : 0,
          lastMeterReadingUpdatedDate:
            this.deviceDetails?.lastMeterReadingUpdatedDate !== ''
              ? new Date(this.deviceDetails?.lastMeterReadingUpdatedDate)
              : null,
          deviceId: this.deviceForm.get('deviceId')?.value,
          canId: this.deviceForm.get('canId')?.value,
        };

        console.log(payload);

        this.store.dispatch(
          updatedevice({
            deviceData: payload,
            id: this.deviceDetails.id,
          }),
        );
      }
    }
  }
}
